import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { TicketTextRegular } from 'components/common/fontElements';

export const Container = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 0px 25px 150px;
  height: 100%;
  overflow: scroll;
`;

export const PageHeader = styled.div`
  padding: 30px 0px 0px;
  text-align: center;
`;

export const TitleText = styled.p`
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.black1};
  margin: 15px 25px;
`;

export const SubText = styled.p`
  color: ${colors.darkGray1};
`;

export const MacroContentSection = styled(TicketTextRegular)`
  white-space: normal;
  position: relative;
  color: ${colors.black4};
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: normal;

  padding: 35px 35px 50px;
  margin: 15px 0px;
  border: 1px solid ${colors.lightGray15};
  border-radius: 4px;

  img {
    max-width: 100%;
  }
`;

export const ValidateSection = styled.div`
  margin 40px 0px;
  border-top: 3px solid ${colors.lightGray14};
  text-align: center;
`;

export const ValidateText = styled.div`
  margin: 25px 0px 15px;
  font-family: Lato;
  font-weight: 500;
`;
